// start with word character
// word character or white space in the betweens
// end with word character
export const ADDRESS_VALIDATION_REGEX =
  /^[^\s]+([(A-Z)(a-z)(\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff)@#&*)(+_?'.,-\d\s]*)$/;
export const NAME_VALIDATION_REGEX = /^[\w][\w ]{0,28}[\w ]$/;
export const LATIN_NAME_VALIDATION_REGEX =
  /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff])\D{0,29}$/;
// Latin extended email validation regex
export const EMAIL_VALIDATION_REGEX =
  /^(?!.*\.\.)([A-Za-z0-9._%'+-]*[A-Za-z0-9_-]+@[A-Za-z0-9]+[A-Za-z0-9.-]*.[A-Za-z]{2,})$/i;
export const MOBILE_NUMBER_VALIDATION_REGEX = /^(\d*)?$/;
export const NUMBER_ONLY_REGEX = /^([0-9]\d*)?$/;
export const SPACE_ONLY_REGEX = /\S/;
export const ALL_NUMBERS_WITH_DECIMAL_REGEX = /^(0|[1-9]\d*)(\.\d+)?$/;
export const NOT_NUMBER_REGEX = /[^0-9]+/g;
export const NOT_CONTAIN_HTML_CHAR = /^[^<>\/]*$/;
export const ONLY_US_ASCII_CHARACTERS = /^[\x00-\x7F]+$/;
export const ONLY_WORDS = /^[\w.+ -]*$/;
export const CREDIT_CARD_NUMBER_REGEX = /^(\d{4}\s{0,1}){4}?$/;
export const CREDIT_CARD_EXPIRATION_REGEX =
  /^(([0][1-9])|([1][0-2]))(\s){0,1}(\/){0,1}(\s){0,1}([0-9][0-9])?$/;
export const ANZ_BSB_VALIDATION_REGEX = /^01\d{4}$/;
export const ANZ_ACCOUNT_NUMBER_VALIDATION_REGEX = /^\d{9}$/;
export const AUSTRALIAN_PHONE_NUMBER_REGEX = /^04\d{8}$/;
export const DATEPICKER_DATEFORMAT_YYYY_SLASH_MM_SLASH_DD =
  /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
